import { CUSTOM_LIST_SERVICE_KEY_IN_SERVICES } from '../services/constants';

export const MLAServices = [
  'Transactions',
  'EntityHistory',
  'EntityAccountHistory',
  'AttributeHistory',
  'AlloyHistory',
  'AccountHistory',
  'IdentityElementVelocity',
  CUSTOM_LIST_SERVICE_KEY_IN_SERVICES,
];

export enum MLATokenType {
  FOOTNOTE = 'footnote',
  FILTER = 'filter',
}

export const MLAType = {
  THRESHOLD_LEFT: 'thresholdLeft',
  THRESHOLD_RIGHT: 'thresholdRight',
  DATAROUTE: 'dataroute',
} as const;
